import { Directive } from '@angular/core';

/**
 * Applies VetAI-themed custom scrollbar styling to a scrollable element when supported.
 * The host element must set its own overflow (e.g. `overflow-y: auto`).
 *
 * @example
 * ```html
 * <div joii-scrollbar class="overflow-y-auto max-h-80">...</div>
 * ```
 */
@Directive({
  selector: '[joii-scrollbar]',
})
export class ScrollbarDirective {}
